import { render, staticRenderFns } from "./AiTask.vue?vue&type=template&id=5bf557c7&scoped=true"
import script from "./AiTask.vue?vue&type=script&lang=js"
export * from "./AiTask.vue?vue&type=script&lang=js"
import style0 from "./AiTask.vue?vue&type=style&index=0&id=5bf557c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf557c7",
  null
  
)

export default component.exports